export default {
	data(){
		return {
			tableGBoptions: { 
			},

			tableGBSearch: ['datos_afiliado/documento','datos_afiliado/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento', sort: null, sortTable: 'datos_afiliado/documento'},
					tbody: { td: ['datos_afiliado/documento',]}
				},
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_afiliado/telefonos'],}
				},
				{
					thead: { th: 'Fecha', },
					tbody: { td: ['info_afiliacion/fecha'],}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'],}
				},
			],			
		
		}
	},
}